import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { useQuery } from '@tanstack/react-query';
import { ContentsRelayRequestDto } from '@diritto/common/relay/dtos/content-relay.dtos';

export const usePostRelayContentsQuery = (contentRelayRequestDto: ContentsRelayRequestDto) =>
  useQuery({
    queryKey: relayQueryKey.contentList(contentRelayRequestDto),
    queryFn: () => RelayApi.contents(contentRelayRequestDto),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 10,
  });
